import { useEffect, useState } from "react";
import axios from "axios";
import StudentsTable from "./Table/studentTable";

import { ChatState } from "../../Context/ChatProvider";
import "./style.css";
import { useToast } from "@chakra-ui/react";
import Student_crud from "./student/studentForm";
import StudentsTableIn from "./Table/studentTableinscription";



function StudentsIn() {
	const [fetchAgain, setFetchAgain] = useState(false);
	const toast = useToast();
	const [obj, setObj] = useState([]);
	const [search, setSearch] = useState("");
	const [loading, setLoading] = useState(false);

	const {
		user,
	} = ChatState();

	useEffect(() => {
		if(fetchAgain===true || user!=undefined )
		getAllStudents();

	}, [fetchAgain,user]);


	async function getAllStudents() {
		try {
			setObj([])
			setLoading(true);
			const config = {
				headers: {
					Authorization: `Bearer ${user.token}`,
				},
			};
			const { data } = await axios.get(`/api/student`, config)

			setLoading(false);

			setObj(data)

		} catch (error) {
			toast({
				title: "Une erreur s'est produite !",
				duration: 5000,
				isClosable: true,
				position: "bottom-left",
			});
		}
		setFetchAgain(false);
	};




	return (
		<div className=" w-full  flex flex-col">

			
			<div className="">

				<div className="">
					<div className="table_container"> {/*className="table_container"  */}
						<StudentsTableIn data={obj} search={search} loading={loading} setFetchAgain={setFetchAgain} />
					</div>
				</div>
			</div>
		</div>
	);
}

export default StudentsIn;
